import enviro from 'enviro';
export const getContentEmbedUIOrigin = () => {
  const qa = enviro.isProd() ? '' : 'qa';
  return `https://preview.hubspoteditor${qa}.com`;

  // Uncomment this if you want to run [content-embed-ui] locally since
  // benderproxy hosts all local apps on `local.hubspot(qa).com`. Be careful
  // when running [content-embed-ui] locally as the EmbedIframe has `sandbox`
  // of "allow-scripts allow-same-origin" which exposes possible XSS attacks.
  // return `https://local.hubspot${qa}.com`;
};
export const CONTENT_EMBED_UI_BASE_URL = `${getContentEmbedUIOrigin()}/content-embed-ui`;
const actionPrefix = 'ContentEmbedUI';
export const EventActions = {
  READY: `${actionPrefix}:Ready`,
  SIZE_CHANGE: `${actionPrefix}:SizeChange`,
  SET_CONTENT: `${actionPrefix}:SetContent`,
  SET_CONTENT_DONE: `${actionPrefix}:SetContentDone`,
  DISCONNECT: `${actionPrefix}:Disconnect`
};